import {
  DndContext,
  MouseSensor,
  pointerWithin,
  TouchSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';

export default function DraggableContainer({
  onDragEnd,
  onDragStart,
  onDragOver,
  children,
  collisionDetection = pointerWithin,
}) {
  const mouseSensor = useSensor(MouseSensor);
  const touchSensor = useSensor(TouchSensor);
  const sensors = useSensors(mouseSensor, touchSensor);
  return (
    <DndContext
      collisionDetection={collisionDetection}
      onDragOver={onDragOver}
      onDragEnd={onDragEnd}
      onDragStart={onDragStart}
      sensors={sensors}
    >
      {children}
    </DndContext>
  );
}
